import type { SemanticColor } from './semanticColors';
import { semanticColors } from './semanticColors';

const fallbacks: Partial<Record<SemanticColor, SemanticColor>> = {
  borderLight: 'borderPrimary',
  borderPrimary: 'borderLight',
};

const createVarName = (key: string) => `--cb-color-${key}`;

/** @deprecated use color tokens from `@creditornot/cb-ingredients/design-tokens` instead */
export const cbSemanticCssVars: Record<SemanticColor, string> = Object.fromEntries(
  Object.keys(semanticColors.light).map((key) => {
    const fallbackKey = fallbacks[key as SemanticColor];

    return [
      key,
      `var(${createVarName(key)}${fallbackKey ? `, var(${createVarName(fallbackKey)})` : ''})`,
    ];
  }),
) as Record<SemanticColor, string>;
